interface MediaImageProps {
  src: string;
  alt: string;
  className?: string;
  eager?: boolean;
  objectPosition?: string;
  fit?: "cover" | "contain";
}

export default function MediaImage({
  src,
  alt,
  className = "",
  eager = false,
  objectPosition = "object-top",
  fit = "cover",
}: MediaImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      className={`${fit === "cover" ? "object-cover" : "object-contain"} ${objectPosition} ${className}`}
    />
  );
}